var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SearchFacet',{staticStyle:{"margin-bottom":"0.75rem"},attrs:{"kind":"title","title":"Titel","items":_vm.data.titles,"loading":_vm.isLoading},model:{value:(_vm.selection.titles),callback:function ($$v) {_vm.$set(_vm.selection, "titles", $$v)},expression:"selection.titles"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }